/* Storefront guidance for the exact sandwich/Pinsa catalog. This cannot enforce
 * Shopify payment or stop an existing/direct checkout. The paid-order server
 * must still validate and allocate the final pickup independently. */
(function () {
  'use strict';
  var ITEMS = [
    ['9234123391204','49862241321188','sandwich'], ['9234123423972','49862241353956','sandwich'],
    ['9234123456740','49862241452260','sandwich'], ['9234123489508','49862241550564','sandwich'],
    ['9234123522276','49862241681636','sandwich'], ['9234123587812','49862242009316','sandwich'],
    ['9234123620580','49862242042084','sandwich'], ['9234123686116','49862242107620','sandwich'],
    ['9234123751652','49862242336996','sandwich'], ['9234123784420','49862244565220','sandwich'],
    ['15322815299812','67391598559460','pizza'], ['15322815332580','67391598592228','pizza'],
    ['15322815398116','67391598723300','pizza'], ['15322815463652','67391598854372','pizza'],
    ['15322815496420','67391598887140','pizza'], ['15322815529188','67391598919908','pizza'],
    ['15322815561956','67391598952676','pizza'], ['15322815627492','67391599018212','pizza'],
    ['15322815660260','67391599050980','pizza'], ['15322815693028','67391599083748','pizza']
  ];
  var PRODUCT_IDS = new Set(ITEMS.map(function (item) { return item[0]; }));
  var VARIANTS = new Map(ITEMS.map(function (item) { return [item[1], item[0]]; }));
  var STORAGE = 'bc_normal_pickup_v2_hold';
  var ATTRIBUTES = ['bc_ordering_flow','bc_pickup_at','bc_prep_minutes','bc_pickup_mode','bc_pickup_reservation','bc_pickup_token','bc_pickup_requested_at'];
  function iso(value) { return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/.test(value) && Number.isFinite(Date.parse(value)); }
  function credentials(value) { return value && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.reservationId || '') && /^[A-Za-z0-9_-]{43}$/.test(value.reservationToken || ''); }
  function normalPresent(items) { return items.some(function (item) { return PRODUCT_IDS.has(String(item.product_id)) || VARIANTS.has(String(item.variant_id)); }); }
  function canonical(lines, ajax) {
    if (!Array.isArray(lines)) return null;
    var result = new Map();
    for (var line of lines) {
      if (!line || typeof line !== 'object') return null;
      var productId = String(ajax ? line.product_id : line.productId), variantId = String(ajax ? line.variant_id : line.variantId);
      if (VARIANTS.get(variantId) !== productId || !Number.isSafeInteger(line.quantity) || line.quantity < 1) return null;
      var old = result.get(variantId); result.set(variantId, { productId: productId, variantId: variantId, quantity: (old ? old.quantity : 0) + line.quantity });
    }
    return Array.from(result.values()).sort(function (a, b) { return a.variantId.localeCompare(b.variantId); });
  }
  function inspectCart(cart, saved) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('Your cart could not be checked. Please try again.');
    var attributes = cart.attributes || {};
    if (!normalPresent(cart.items)) return { kind: 'native', cleanup: attributes.bc_ordering_flow === 'normal_pickup_v2' };
    var lines = canonical(cart.items, true);
    if (!lines) return { kind: 'pickup', reason: 'mixed_or_unknown' };
    if (typeof cart.note === 'string' && cart.note.length > 400) return { kind: 'pickup', reason: 'note_length' };
    if (lines.reduce(function (sum, line) { return sum + line.quantity; }, 0) > 10) return { kind: 'pickup', reason: 'quantity' };
    var proof = { reservationId: attributes.bc_pickup_reservation, reservationToken: attributes.bc_pickup_token };
    if (attributes.bc_ordering_flow !== 'normal_pickup_v2' || attributes.bc_prep_minutes !== '20' || !credentials(proof)
      || !iso(attributes.bc_pickup_at) || !['asap','scheduled'].includes(attributes.bc_pickup_mode)
      || (attributes.bc_pickup_mode === 'scheduled' && !iso(attributes.bc_pickup_requested_at))
      || (attributes.bc_pickup_mode === 'asap' && attributes.bc_pickup_requested_at)) return { kind: 'pickup', reason: 'missing_details' };
    // Browser binding detects ordinary cart edits; it is not an authorization
    // credential. The server verifies the original cart independently after pay.
    if (!credentials(saved) || saved.reservationId !== proof.reservationId || saved.reservationToken !== proof.reservationToken
      || saved.pickupAt !== attributes.bc_pickup_at || saved.mode !== attributes.bc_pickup_mode
      || (saved.requestedPickupAt || '') !== (attributes.bc_pickup_requested_at || '')
      || JSON.stringify(canonical(saved.cartLines, false)) !== JSON.stringify(lines)) return { kind: 'pickup', reason: 'changed_cart' };
    return { kind: 'check_hold', proof: proof, pickupAt: attributes.bc_pickup_at, lines: lines };
  }
  function staleAttributes() { return Object.fromEntries(ATTRIBUTES.map(function (key) { return [key, '']; })); }
  async function checkoutDecision(ports) {
    var cart = await ports.readCart(), saved = ports.readSaved(), decision = inspectCart(cart, saved);
    if (decision.kind === 'native') {
      if (decision.cleanup) {
        // Clear only this flow's stale markers, never meal properties or other
        // attributes, so a later preorder does not enter the normal paid relay.
        await ports.updateCart({ attributes: staleAttributes() });
        var updated = await ports.readCart();
        if (normalPresent(updated.items)) return { kind: 'pickup', reason: 'changed_cart' };
        if ((updated.attributes || {}).bc_ordering_flow === 'normal_pickup_v2') throw new Error('Your cart details could not be refreshed. Please try again.');
      }
      return { kind: 'native' };
    }
    if (decision.kind !== 'check_hold') return decision;
    try {
      var result = await ports.status(decision.proof);
      if (!result || result.ok !== true || result.status !== 'held' || !iso(result.serverNow) || result.pickupAt !== decision.pickupAt
        || Date.parse(decision.pickupAt) - Date.parse(result.serverNow) <= 20 * 60000) return { kind: 'pickup', reason: 'expired_hold' };
      var fresh = inspectCart(await ports.readCart(), ports.readSaved());
      if (fresh.kind !== 'check_hold' || JSON.stringify(fresh) !== JSON.stringify(decision)) return { kind: 'pickup', reason: 'changed_cart' };
      return { kind: 'native' };
    } catch (_) { return { kind: 'pickup', reason: 'unverified_hold' }; }
  }
  function normalPermalink(pathname) {
    var match = /\/cart\/([0-9:,]+)\/?$/.exec(pathname);
    return !!match && match[1].split(',').some(function (pair) { return VARIANTS.has(pair.split(':')[0]); });
  }
  function pickupBrowsePage(pathname) {
    var match = /\/pages\/(menu|sandwiches|pinsas)\/?$/.exec(pathname);
    return match ? match[1] : null;
  }
  function wirePickupBrowse(doc, pathname, target) {
    var page = pickupBrowsePage(pathname);
    if (!page) return;
    var root = page === 'menu'
      ? doc.querySelector('[data-bc-concept-mount][data-bc-page-kind="menu"]')
      : doc.querySelector('[data-bc-specialty][data-page-kind="' + page + '"]' + (page === 'sandwiches' ? ', .bc-sandwiches' : ''));
    if (!root) return;
    function link(label, className) {
      var anchor = doc.createElement('a'); anchor.href = target; anchor.textContent = label;
      anchor.setAttribute('data-bc-normal-pickup-link', '');
      if (className) anchor.className = className;
      return anchor;
    }
    // The concept loader also inserts a pause notice on catering. Only these
    // three browsing routes are in scope; retain its marker to avoid reinsertion.
    root.querySelectorAll('[data-bc-ordering-pause], aside[aria-label="Online ordering update"]').forEach(function (notice) {
      // Its legacy route repair rewrites the exact label "Order pickup" into a
      // phone link. This specific label stays outside that rule. Repair a banner
      // made by the previous asset once, then perform no further DOM writes.
      if (notice.dataset.bcNormalPickupNotice === 'true') {
        var existing = notice.querySelector('[data-bc-normal-pickup-link]');
        if (existing) {
          if (existing.getAttribute('href') !== target) existing.setAttribute('href', target);
          if (existing.textContent !== 'Order pickup online') existing.textContent = 'Order pickup online';
        }
        return;
      }
      if (!/Online ordering (?:will be available soon|coming soon)/i.test(notice.textContent || '')) return;
      notice.dataset.bcNormalPickupNotice = 'true';
      var heading = doc.createElement('strong'); heading.textContent = 'Sandwich and pinsa pickup';
      var copy = doc.createElement('span'); copy.textContent = ' Choose your items and check available pickup times. Pre-order meals and catering have separate ordering. ';
      var action = link('Order pickup online'); action.style.cssText = 'display:inline-block;color:inherit;font-weight:600;text-decoration:underline;padding:6px 0';
      notice.replaceChildren(heading, copy, action);
    });
    if (page === 'menu') {
      ['sandwiches', 'pinsas'].forEach(function (category) {
        var heading = root.querySelector('#' + category + ' > div:first-child');
        if (!heading || heading.querySelector('[data-bc-normal-pickup-link]')) return;
        var action = link('Order ' + category + ' for pickup');
        action.style.cssText = 'display:inline-block;background:#8fc2ba;color:#0f4147;font:600 15px/1.4 Outfit,Arial,sans-serif;padding:12px 20px;border-radius:999px;text-decoration:none';
        heading.appendChild(action);
      });
    } else {
      var actions = root.querySelector('.bc-specialty__hero-actions, .bc-sandwiches__hero-actions');
      if (actions && !actions.querySelector('[data-bc-normal-pickup-link]')) {
        actions.prepend(link('Order pickup', root.classList.contains('bc-sandwiches') ? 'bc-button bc-button--mint' : 'bc-specialty__button bc-specialty__button--solid'));
      }
    }
  }

  function start() {
    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    if (!/^\/[A-Za-z0-9/_-]*$/.test(routeRoot)) routeRoot = '/';
    var target = routeRoot + 'pages/order-pickup', busy = false, permitClick = null, permitSubmit = null;
    if (pickupBrowsePage(window.location.pathname)) {
      var browseRefreshPending = false;
      var refreshBrowse = function () {
        if (browseRefreshPending) return;
        browseRefreshPending = true;
        setTimeout(function () { browseRefreshPending = false; wirePickupBrowse(document, window.location.pathname, target); }, 30);
      };
      refreshBrowse();
      // Concept markup and its pause notice arrive after DOMContentLoaded.
      if (typeof MutationObserver === 'function' && document.body) new MutationObserver(refreshBrowse).observe(document.body, { childList: true, subtree: true });
    }
    function saved() { try { return JSON.parse(localStorage.getItem(STORAGE) || 'null'); } catch (_) { return null; } }
    async function json(url, body, remote) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 12000);
      try {
        var response = await fetch(url, { method: body === undefined ? 'GET' : 'POST', cache: 'no-store', credentials: remote ? 'omit' : 'same-origin',
          signal: controller.signal, headers: { 'Content-Type': 'application/json' }, body: body === undefined ? undefined : JSON.stringify(body) });
        if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
        return await response.json();
      } finally { clearTimeout(timer); }
    }
    var ports = { readSaved: saved, readCart: function () { return json(routeRoot + 'cart.js'); }, updateCart: function (body) { return json(routeRoot + 'cart/update.js', body); },
      status: function (body) { return json('https://buon-cibo-reporting-portal.vercel.app/api/normal-pickup/status', body, true); } };
    function notice(message) {
      var box = document.getElementById('bc-normal-cart-guidance');
      if (!box) { box = document.createElement('div'); box.id = 'bc-normal-cart-guidance'; box.setAttribute('role','status'); box.style.cssText = 'padding:16px 20px;margin:16px auto;max-width:1200px;background:#eff5f2;color:#103f45;border:1px solid #d5e2dd;border-radius:8px;font:16px/1.5 Outfit,Arial,sans-serif'; (document.getElementById('MainContent') || document.body).prepend(box); }
      box.replaceChildren(); var text = document.createElement('p'); text.textContent = message; box.append(text);
      var link = document.createElement('a'); link.href = target; link.textContent = 'Review sandwich and pinsa pickup'; link.style.cssText = 'color:inherit;text-decoration:underline'; box.append(link);
    }
    function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
    async function guard(control, resume) {
      if (busy) return; busy = true;
      var wasDisabled = control && control.disabled; if (control) { control.setAttribute('aria-busy','true'); if ('disabled' in control) control.disabled = true; }
      try {
        var decision = await checkoutDecision(ports);
        if (control && 'disabled' in control) control.disabled = wasDisabled;
        if (decision.kind === 'native') resume(); else window.location.assign(target);
      } catch (_) { notice('Your cart could not be checked. Please try checkout again.'); }
      finally { busy = false; if (control) { control.removeAttribute('aria-busy'); if ('disabled' in control) control.disabled = wasDisabled; } }
    }
    function checkoutLink(anchor) {
      if (!anchor || !anchor.href) return false;
      try { var url = new URL(anchor.href, window.location.href); return url.origin === window.location.origin && (/\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname) || /\/cart\/?$/.test(url.pathname) && url.searchParams.has('checkout')); } catch (_) { return false; }
    }
    window.addEventListener('click', function (event) {
      var clicked = event.target && event.target.closest ? event.target : null; if (!clicked) return;
      var control = clicked.closest('button[name="checkout"], input[name="checkout"], [data-checkout], a[href]');
      if (!control) return;
      if (permitClick === control) { permitClick = null; return; }
      if (control.tagName === 'A') {
        try { var url = new URL(control.href, window.location.href); if (url.origin === window.location.origin && normalPermalink(url.pathname)) { stop(event); window.location.assign(target); return; } } catch (_) {}
        if (!checkoutLink(control)) return;
      }
      stop(event);
      guard(control, function () { permitClick = control; permitSubmit = control.form || null; control.click(); setTimeout(function () { permitClick = null; permitSubmit = null; }, 0); });
    }, true);
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (permitSubmit === form) { permitSubmit = null; return; }
      if (!form || !form.action) return;
      var action; try { action = new URL(form.action, window.location.href); } catch (_) { return; }
      if (action.origin !== window.location.origin) return;
      if (/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) {
        var field = form.elements && form.elements.namedItem('id');
        if (field && VARIANTS.has(String(field.value))) { stop(event); window.location.assign(target); }
        return;
      }
      var submitter = event.submitter;
      if (!(submitter && submitter.name === 'checkout') && !/\/(?:checkout|checkouts)(?:\/|$)/.test(action.pathname)) return;
      stop(event);
      guard(submitter, function () { permitSubmit = form; if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined); else { permitSubmit = null; notice('Please use the checkout button in your cart.'); } });
    }, true);
    // Server-rendered initial flag prevents normal-cart wallet shortcuts from
    // flashing. Fresh cart reads refresh that flag; preorder-only pages retain it.
    if (/\/cart\/?$/.test(window.location.pathname) || document.documentElement.dataset.bcNormalCart === 'true') {
      ports.readCart().then(function (cart) { var normal = normalPresent(cart.items || []); document.documentElement.dataset.bcNormalCart = String(normal);
        if (normal && /\/cart\/?$/.test(window.location.pathname)) notice('Sandwiches and pinsas need pickup details before checkout. Preorders must be checked out separately.'); }).catch(function () {});
    }
    var product = ITEMS.find(function (item) { return item[0] === document.documentElement.dataset.bcNormalProduct; });
    if (product) { var category = document.querySelector('#bc-normal-pickup [data-category="' + product[2] + '"]'); if (category) category.click(); }
  }
  if (typeof module === 'object' && module.exports) module.exports = { items: ITEMS, inspectCart: inspectCart, checkoutDecision: checkoutDecision, canonical: canonical, normalPermalink: normalPermalink, staleAttributes: staleAttributes, pickupBrowsePage: pickupBrowsePage, wirePickupBrowse: wirePickupBrowse };
  else if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
}());
